import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCommand, FiShoppingCart, FiMenu, FiX, FiActivity } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'DASHBOARD', href: '#dashboard' },
    { label: 'MODULES', href: '#modules' },
    { label: 'BUILDER', href: '#builder' },
    { label: 'SPECS', href: '#specs' },
  ];

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-graphite-900/95 backdrop-blur-md border-b border-electric/20 py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        
        <div className="flex items-center gap-3">
          <div className="p-2 bg-electric rounded-sm">
            <SafeIcon icon={FiCommand} className="text-graphite-900 text-xl" />
          </div>
          <span className="fids-text font-bold text-2xl tracking-tighter hidden sm:block">
            KAIRO<span className="text-electric">KIT</span>
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map(link => (
            <a key={link.label} href={link.href} className="fids-text text-xs font-medium text-gray-400 hover:text-electric transition-colors tracking-widest">
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-6">
          <div className="hidden lg:flex items-center gap-2 fids-text text-[10px] text-green-400">
            <SafeIcon icon={FiActivity} className="animate-pulse" />
            SYS_NORMAL
          </div>
          <button className="relative group p-2">
            <SafeIcon icon={FiShoppingCart} className="text-xl text-gray-300 group-hover:text-electric transition-colors" />
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-electric text-graphite-900 text-[10px] font-bold flex items-center justify-center rounded-full">2</span>
          </button>
          <button className="md:hidden text-gray-300" onClick={() => setIsOpen(!isOpen)}>
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute top-full left-0 w-full bg-graphite-800 border-b border-graphite-700 p-6 md:hidden"
          >
            <div className="flex flex-col gap-6">
              {navLinks.map(link => (
                <a key={link.label} href={link.href} onClick={() => setIsOpen(false)} className="fids-text text-sm tracking-widest text-gray-300 hover:text-electric">
                  {link.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;